import { Injectable } from '@angular/core';
import { ListDefinitionService } from '../../services';
import { listDefinitionLoadComplete, listDefinitionLoadStart } from './list-definitions.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

@Injectable()
export class ListDefinitionsEffects {

    constructor(private listDefinitionService: ListDefinitionService,
                private actions$: Actions) {
    }

    public loadDefinitions$ = createEffect(() => this.actions$
        .pipe(
            ofType(listDefinitionLoadStart),
            mergeMap(action => {
                return this.listDefinitionService.getByType(action.listDefinitionType)
                    .pipe(map(listDefinition =>
                        listDefinitionLoadComplete({ definition: { [ action.listDefinitionType ]: listDefinition } })));
            })));
}